/**
 * External dependencies
 */
import {
	ImageUploadPlaceholder, ColumnControl,IconControl, IconDisplay
} from '~cartzillagb/components'
import {
	withTabbedInspector,
} from '~cartzillagb/higher-order'
import classnames from 'classnames'
import { getBootstrapClasses, range } from '~cartzillagb/util'
import { i18n } from 'cartzillagb'

/**
 * WordPress dependencies
 */
import {
	PanelBody, ToggleControl, RangeControl
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { RichText } from '@wordpress/block-editor'
import { addFilter, applyFilters } from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'
import { compose } from '@wordpress/compose'

addFilter( 'cartzillagb.outlet-store.edit.inspector.style.before', 'cartzillagb/outlet-store', ( output, props ) => {
	const { attributes, setAttributes } = props
	const {
		enableContainer,
		listlimit,
		limit,
		lgColumns,
		smColumns,
	} = attributes

	return (
		<Fragment>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
				<ToggleControl
					label={ __( 'Enable Container', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
				<RangeControl
					label={ __( 'Limit' ) }
					value={ limit }
					onChange={ limit => setAttributes( { limit } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.outlet-store.edit.inspector.max.limit', 12 ) }
				/>
				<RangeControl
					label={ __( 'List Limit' ) }
					value={ listlimit }
					onChange={ listlimit => setAttributes( { listlimit } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.outlet-store.edit.inspector.max.limit', 12 ) }
				/>
				<ColumnControl
					label={ __("Column Width", i18n ) }
					lgColumns={ lgColumns }
					lgMin={ 1 }
					lgMax={ 12 }
					smColumns={ smColumns }
					smMin={ 1 }
					smMax={ 12 }
					onChangelg={ value => setAttributes( { lgColumns: value } ) }
					onChangesm={ value => setAttributes( { smColumns: value } ) }
				/>
			</PanelBody>
			{ range( 1, limit + 1 ).map( i => {
				return (
					<PanelBody title={ __( `Contact List Settings #${ i }`, i18n ) } initialOpen={ true } key={ i }>
						<div className="icon-control-componet-wrapper">
							{ range( 1, listlimit + 1 ).map( j => {

								let defaulticon =''

								if ( (j % 3 ) === 1 ) {
									defaulticon='czi-location' 
								}

							   if ( (j % 3 ) === 2 ) {
									defaulticon='czi-phone'
								}

								if ( (j % 3 ) === 0 ) {
									defaulticon='czi-mail'
								}

								const Icon = attributes[ `icon${ i }${ j }` ]

								return (
									<IconControl
										key={ i }
										label={ __( `Icon #${ j }`, i18n ) }
										value={ Icon || defaulticon }
										onChange={ Icon => setAttributes( { [ `icon${ i }${ j }` ]: Icon } ) }
									/>
								)
							} ) }
						</div>
					</PanelBody>
				)
			} ) }
		</Fragment>
	)
} )

const edit = props => {
	const {
		setAttributes, className, attributes,
	} = props

	const {
		enableContainer,
		listlimit,
		limit,
		heading,
		lgColumns,
		smColumns,
	} = attributes

	const mainClasses = classnames( [
		className,
		'pt-4 mt-md-4 mb-5',
		'outet-store-block'
	], applyFilters( 'cartzillagb.outlet-store.main-block.classes', {
		'container': enableContainer,
	}, props ) )

	const headingComp = (
		<RichText
			tagName='h2'
			className="h3 text-center mb-3"
			value={ heading || 'Partner outlet stores' }
			onChange={ heading => setAttributes( { heading } ) }
			placeholder={ __( 'heading' ) }
			keepPlaceholderOnFocus
		/>
	)


	const content = range( 1, ( limit ) + 1 ).map( i => {

		const mediaURL = attributes[ `mediaURL${ i }` ]
		const name = attributes[ `name${ i }` ]

		let defaultname =''

		if ( (i % 3 ) === 1 ) {
			defaultname=(__("Orlando, USA", i18n))            
		}

		if ( (i % 3 ) === 2 ) {
			defaultname=(__("Chicago, USA", i18n))
		}

		if ( (i % 3 ) === 0 ) {
			defaultname=(__("New York, USA", i18n))
		}

		const imageComp = (
			<ImageUploadPlaceholder
				className={ `czgb-outlet-store__image` }
				imageURL={ mediaURL }
				onRemove={ () => {
					setAttributes( {
						[ `mediaURL${ i }` ]: '',
					} )
				} }
				onChange={ ( { url } ) => {
					setAttributes( {
						[ `mediaURL${ i }` ]: url,
					} )
				} }
				hasRemove={ false }
				render={ <img src={ mediaURL } className="card-img-top" alt={ __( 'Orlando' ) } /> }
			/>
		)

		const nameComp = (
			<RichText
				tagName='h6'
				value={ name || defaultname }
				onChange={ name => setAttributes( { [ `name${ i }` ]: name } ) }
				placeholder={ __( 'Name' ) }
				keepPlaceholderOnFocus
			/>
		)

		const bootstrapClass = getBootstrapClasses( undefined, smColumns, undefined, lgColumns )

		const output = (
			<div className={ `${ bootstrapClass } mb-grid-gutter` }  key={ i }>
				<div className="card border-0 box-shadow">
					{ imageComp }
					<div className="card-body">
						{ nameComp }
						<ul className="list-unstyled mb-0">
							{ range( 1, listlimit + 1 ).map( j => { 

								const liClasses = classnames( [
									j === 1 && 'pb-3 border-bottom',
								], 
								applyFilters( 'cartzillagb.outlet-store.liclasses', {
								   'pt-2' : listlimit === j,
								   'pt-2 pb-3 border-bottom' : listlimit !== j && j !== 1
								}, props ) )

								let defaulticonname = ''
								let defaulticondesc =''
								let defaulticon =''

								if ( (j % 3 ) === 1 ) {
									defaulticonname=(__("Find us", i18n))
									defaulticon='czi-location' 
								}

							   if ( (j % 3 ) === 2 ) {
									defaulticonname=(__("Call us", i18n))
									defaulticon='czi-phone'
								}

								if ( (j % 3 ) === 0 ) {
									defaulticonname=(__("Write us", i18n))
									defaulticon='czi-mail'
								}

								if ( ( (i % 3 ) === 1 ) && ( (j % 3 ) === 1 ) ) {
									defaulticondesc=(__("514 S. Magnolia St. Orlando, FL 32806, USA", i18n))
								}

								if ( ( (i % 3 ) === 1 ) && ( (j % 3 ) === 2 ) ) {
									defaulticondesc=(__("+1 (786) 322 560 40", i18n))
								}

								if ( ( (i % 3 ) === 1 ) && ( (j % 3 ) === 0 ) ) {
									defaulticondesc=(__("orlando@example.com", i18n))
								}

								if ( ( (i % 3 ) === 2 ) && ( (j % 3 ) === 1 ) ) {
									defaulticondesc=(__("769, Industrial, West Chicago, IL 60185, USA", i18n))
								}

							   if ( ( (i % 3 ) === 2 ) && ( (j % 3 ) === 2 ) ) {
									defaulticondesc=(__("+1 (847) 252 765 33", i18n))
								}

								if ( ( (i % 3 ) === 2 ) && ( (j % 3 ) === 0 ) ) {
									defaulticondesc=(__("chicago@example.com", i18n))
								}

								if ( ( (i % 3 ) === 0 ) && ( (j % 3 ) === 1 ) ) {
									defaulticondesc=(__("396 Lillian Blvd, Holbrook, NY 11741, USA", i18n))
								}

							   if ( ( (i % 3 ) === 0 ) && ( (j % 3 ) === 2 ) ) {
									defaulticondesc=(__("+1 (212) 477 690 000", i18n))
								}

								if ( ( (i % 3 ) === 0 ) && ( (j % 3 ) === 0 ) ) {
									defaulticondesc=(__("newyork@example.com", i18n))
								}

								const iconname       = attributes[ `iconname${ i }${ j }` ]
								const icondesc       = attributes[ `icondesc${ i }${ j }` ]
								const Icon           = attributes[ `icon${ i }${ j }` ]

								const iconnameComp = (
									<RichText
										tagName="span"
										className="font-size-ms text-muted"
										value={ iconname || defaulticonname }
										onChange={ iconname => setAttributes( { [ `iconname${ i }${ j }` ]: iconname } ) }
										placeholder={ __( 'Icon Name', i18n ) }
										keepPlaceholderOnFocus
									/>
								)
								const icondescComp = (
									<RichText
										value={ icondesc || defaulticondesc }
										onChange={ icondesc => setAttributes( { [ `icondesc${ i }${ j }` ]: icondesc } ) }
										placeholder={ __( 'Icon Description', i18n ) }
										keepPlaceholderOnFocus
									/>
								)
								const iconComp = (
									<IconDisplay 
										value={ Icon || defaulticon }
										additionalClass="font-size-lg mt-2 mb-0 text-primary"
									/>    
								)

								return ( 
									<li className={ `${liClasses} media` } key={ i }>
										{ iconComp }
										<div className="media-body pl-3">
											{ iconnameComp }
											<span className="d-block text-heading font-size-sm">{ icondescComp }</span>
										</div>
									</li>
								) 
							} ) }
						</ul>                        
					</div>
				</div>
			</div>
		)

		return output
	} )
		

	return (
		<div className={ mainClasses }>
			<Fragment>
				{ headingComp }
				<div className="row pt-4">
					{ content }
				</div>
			</Fragment>
		</div>
	)  
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )